import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionItemProps,
  AccordionPanel,
  Box,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

interface IOwnProps extends AccordionItemProps {
  title: string;
  children: ReactNode | ReactNode[];
  gapPanel?: number | number[];
  titleFontSize?: string;
}

const AccordionTemplate: React.FC<IOwnProps> = ({
  title,
  children,
  gapPanel,
  titleFontSize = ['14px', '15px', '16px', '18px'],
  ...rest
}) => {
  return (
    <AccordionItem {...rest}>
      <h2>
        <AccordionButton p={1.5} bg="primaryColor" color="white" borderRadius={4} _hover={'none'}>
          <Box as="span" flex="1" textAlign="center" fontSize={titleFontSize} fontWeight={'bold'}>
            {title}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel display="flex" flexDir="column" gap={gapPanel} pb={4}>
        {children}
      </AccordionPanel>
    </AccordionItem>
  );
};

export default AccordionTemplate;
